import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21f2efa6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "complaint-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "harmful-title"
}, [/*#__PURE__*/_createElementVNode("h4", null, "有害信息投诉")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "harmful-hint --van-doc-text-color-1"
}, " 请选择投诉原因 ", -1));
const _hoisted_4 = {
  style: {
    "margin": "20px"
  }
};
import { onMounted, ref } from "vue";
import axios from "axios";
import { showFailToast, showSuccessToast } from "vant";
export default {
  __name: 'ComplaintHarmfulComponents',
  props: {
    complaintId: String
  },
  setup(__props) {
    const checked = ref(-1);
    const prop = __props;
    console.log('complaintId', prop.complaintId);
    const list = [{
      key: 0,
      title: '政治敏感'
    }, {
      key: 1,
      title: '色情'
    }, {
      key: 2,
      title: '恐怖暴力'
    }, {
      key: 3,
      title: '非法博彩'
    }, {
      key: 4,
      title: '违禁品（药品、管制品等）'
    }];
    const submit = () => {
      console.log('提交', checked.value);
      console.log('举报id', prop.complaintId);
      const item = list.find(v => checked.value === v.key);
      axios.post(`https://server.huichangliang.com/livecode/newComplaint`, {
        "complaintId": prop.complaintId,
        "complaintTitle": document.title,
        "complaintContent": item.title,
        "complaintPhone": ""
      }).then(s => {
        console.log('ssss', s);
        const {
          status,
          data
        } = s;
        if (status === 200 && data) {
          showSuccessToast('投诉成功');
        } else {
          showFailToast('投诉失败，请检查网络后重试！');
        }
      }).catch(() => {
        showFailToast('投诉失败，请检查网络后重试！');
      });
    };
    onMounted(() => {
      document.title = '有害信息投诉';
    });
    return (_ctx, _cache) => {
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_van_radio_group, {
        modelValue: checked.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => checked.value = $event),
        shape: "dot"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, item => {
          return _createVNode(_component_van_cell, {
            key: item.key,
            clickable: "",
            onClick: $event => checked.value = item.key
          }, {
            title: _withCtx(() => [_createVNode(_component_van_radio, {
              name: item.key,
              "checked-color": "#07C160"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
              _: 2
            }, 1032, ["name"])]),
            _: 2
          }, 1032, ["onClick"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_button, {
        type: "success",
        block: "",
        onClick: _cache[1] || (_cache[1] = $event => submit())
      }, {
        default: _withCtx(() => [_createTextVNode("提交反馈")]),
        _: 1
      })])]);
    };
  }
};